function Vn(e, t, n = "info") {
  t = typeof t == "object" ? JSON.stringify(t, null, 4) : t, console[n](`%c💧 Kairos%c@v${window.kairos.version}%c • %c[${e}::${n.toUpperCase()}] %c${t}`, "color: #66C3ED; font-weight: bold;", "color: #AAAAAA;", "color: inherit;", "color: lightgreen;", "color: inherit;")
}
window.kairos = window.kairos || {};
window.kairos.version = "2.3.1";
window.kairos.log = Vn;
window.kairos.log("CoreKairos", "Ready!");
var Te = !1,
  Ne = !1,
  j = [],
  qe = -1;

function $n(e) {
  Un(e)
}

function Un(e) {
  j.includes(e) || j.push(e), Zn()
}

function Xn(e) {
  let t = j.indexOf(e);
  t !== -1 && t > qe && j.splice(t, 1)
}

function Zn() {
  !Ne && !Te && (Te = !0, queueMicrotask(Yn))
}

function Yn() {
  Te = !1, Ne = !0;
  for (let e = 0; e < j.length; e++) j[e](), qe = e;
  j.length = 0, qe = -1, Ne = !1
}
var V, F, $, Lt, Ie = !0;

function er(e) {
  Ie = !1, e(), Ie = !0
}

function tr(e) {
  V = e.reactive, $ = e.release, F = t => e.effect(t, {
    scheduler: n => {
      Ie ? $n(n) : n()
    }
  }), Lt = e.raw
}

function mt(e) {
  F = e
}

function nr(e) {
  let t = () => {};
  return [i => {
    let c = F(i);
    return e._x_effects || (e._x_effects = new Set, e._x_runEffects = () => {
      e._x_effects.forEach(o => o())
    }), e._x_effects.add(c), t = () => {
      c !== void 0 && (e._x_effects.delete(c), $(c))
    }, c
  }, () => {
    t()
  }]
}

function Tt(e, t) {
  let n = !0,
    i, c = F(() => {
      let o = e();
      JSON.stringify(o), n ? i = o : queueMicrotask(() => {
        t(o, i), i = o
      }), n = !1
    });
  return () => $(c)
}
var Nt = [],
  qt = [],
  It = [];

function rr(e) {
  It.push(e)
}

function Ue(e, t) {
  typeof t == "function" ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t)) : (t = e, qt.push(t))
}

function Jt(e) {
  Nt.push(e)
}

function Kt(e, t, n) {
  e._x_attributeCleanups || (e._x_attributeCleanups = {}), e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []), e._x_attributeCleanups[t].push(n)
}

function Mt(e, t) {
  e._x_attributeCleanups && Object.entries(e._x_attributeCleanups)
    .forEach(([n, i]) => {
      (t === void 0 || t.includes(n)) && (i.forEach(c => c()), delete e._x_attributeCleanups[n])
    })
}

function ir(e) {
  for (e._x_effects?.forEach(Xn); e._x_cleanups?.length;) e._x_cleanups.pop()()
}
var Xe = new MutationObserver(tt),
  Ze = !1;

function Ye() {
  Xe.observe(document, {
    subtree: !0,
    childList: !0,
    attributes: !0,
    attributeOldValue: !0
  }), Ze = !0
}

function jt() {
  or(), Xe.disconnect(), Ze = !1
}
var Y = [];

function or() {
  let e = Xe.takeRecords();
  Y.push(() => e.length > 0 && tt(e));
  let t = Y.length;
  queueMicrotask(() => {
    if (Y.length === t)
      for (; Y.length > 0;) Y.shift()()
  })
}

function S(e) {
  if (!Ze) return e();
  jt();
  let t = e();
  return Ye(), t
}
var et = !1,
  _e = [];

function cr() {
  et = !0
}

function ar() {
  et = !1, tt(_e), _e = []
}

function tt(e) {
  if (et) {
    _e = _e.concat(e);
    return
  }
  let t = [],
    n = new Set,
    i = new Map,
    c = new Map;
  for (let o = 0; o < e.length; o++)
    if (!e[o].target._x_ignoreMutationObserver && (e[o].type === "childList" && (e[o].removedNodes.forEach(r => {
        r.nodeType === 1 && r._x_marker && n.add(r)
      }), e[o].addedNodes.forEach(r => {
        if (r.nodeType === 1) {
          if (n.has(r)) {
            n.delete(r);
            return
          }
          r._x_marker || t.push(r)
        }
      })), e[o].type === "attributes")) {
      let r = e[o].target,
        a = e[o].attributeName,
        s = e[o].oldValue,
        u = () => {
          i.has(r) || i.set(r, []), i.get(r)
            .push({
              name: a,
              value: r.getAttribute(a)
            })
        },
        d = () => {
          c.has(r) || c.set(r, []), c.get(r)
            .push(a)
        };
      r.hasAttribute(a) && s === null ? u() : r.hasAttribute(a) ? (d(), u()) : d()
    } c.forEach((o, r) => {
    Mt(r, o)
  }), i.forEach((o, r) => {
    Nt.forEach(a => a(r, o))
  });
  for (let o of n) t.some(r => r.contains(o)) || qt.forEach(r => r(o));
  for (let o of t) o.isConnected && It.forEach(r => r(o));
  t = null, n = null, i = null, c = null
}

function Gt(e) {
  return ae(B(e))
}

function ce(e, t, n) {
  return e._x_dataStack = [t, ...B(n || e)], () => {
    e._x_dataStack = e._x_dataStack.filter(i => i !== t)
  }
}

function B(e) {
  return e._x_dataStack ? e._x_dataStack : typeof ShadowRoot == "function" && e instanceof ShadowRoot ? B(e.host) : e.parentNode ? B(e.parentNode) : []
}

function ae(e) {
  return new Proxy({
    objects: e
  }, sr)
}
var sr = {
  ownKeys({
    objects: e
  }) {
    return Array.from(new Set(e.flatMap(t => Object.keys(t))))
  },
  has({
    objects: e
  }, t) {
    return t == Symbol.unscopables ? !1 : e.some(n => Object.prototype.hasOwnProperty.call(n, t) || Reflect.has(n, t))
  },
  get({
    objects: e
  }, t, n) {
    return t == "toJSON" ? ur : Reflect.get(e.find(i => Reflect.has(i, t)) || {}, t, n)
  },
  set({
    objects: e
  }, t, n, i) {
    const c = e.find(r => Object.prototype.hasOwnProperty.call(r, t)) || e[e.length - 1],
      o = Object.getOwnPropertyDescriptor(c, t);
    return o?.set && o?.get ? o.set.call(i, n) || !0 : Reflect.set(c, t, n)
  }
};

function ur() {
  return Reflect.ownKeys(this)
    .reduce((t, n) => (t[n] = Reflect.get(this, n), t), {})
}

function Ht(e) {
  let t = i => typeof i == "object" && !Array.isArray(i) && i !== null,
    n = (i, c = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(i))
        .forEach(([o, {
          value: r,
          enumerable: a
        }]) => {
          if (a === !1 || r === void 0 || typeof r == "object" && r !== null && r.__v_skip) return;
          let s = c === "" ? o : `${c}.${o}`;
          typeof r == "object" && r !== null && r._x_interceptor ? i[o] = r.initialize(e, s, o) : t(r) && r !== i && !(r instanceof Element) && n(r, s)
        })
    };
  return n(e)
}

function Qt(e, t = () => {}) {
  let n = {
    initialValue: void 0,
    _x_interceptor: !0,
    initialize(i, c, o) {
      return e(this.initialValue, () => fr(i, c), r => Je(i, c, r), c, o)
    }
  };
  return t(n), i => {
    if (typeof i == "object" && i !== null && i._x_interceptor) {
      let c = n.initialize.bind(n);
      n.initialize = (o, r, a) => {
        let s = i.initialize(o, r, a);
        return n.initialValue = s, c(o, r, a)
      }
    } else n.initialValue = i;
    return n
  }
}

function fr(e, t) {
  return t.split(".")
    .reduce((n, i) => n[i], e)
}

function Je(e, t, n) {
  if (typeof t == "string" && (t = t.split(".")), t.length === 1) e[t[0]] = n;
  else {
    if (t.length === 0) throw error;
    return e[t[0]] || (e[t[0]] = {}), Je(e[t[0]], t.slice(1), n)
  }
}
var Dt = {};

function E(e, t) {
  Dt[e] = t
}

function Ke(e, t) {
  let n = dr(t);
  return Object.entries(Dt)
    .forEach(([i, c]) => {
      Object.defineProperty(e, `$${i}`, {
        get() {
          return c(t, n)
        },
        enumerable: !1
      })
    }), e
}

function dr(e) {
  let [t, n] = Ut(e), i = {
    interceptor: Qt,
    ...t
  };
  return Ue(e, n), i
}

function lr(e, t, n, ...i) {
  try {
    return n(...i)
  } catch (c) {
    oe(c, e, t)
  }
}

function oe(e, t, n = void 0) {
  e = Object.assign(e ?? {
    message: "No error message given."
  }, {
    el: t,
    expression: n
  }), console.warn(`Alpine Expression Error: ${e.message}

${n?'Expression: "'+n+`"

`:""}`, t), setTimeout(() => {
    throw e
  }, 0)
}
var We = !0;

function Ft(e) {
  let t = We;
  We = !1;
  let n = e();
  return We = t, n
}

function G(e, t, n = {}) {
  let i;
  return O(e, t)(c => i = c, n), i
}

function O(...e) {
  return Bt(...e)
}
var Bt = zt;

function xr(e) {
  Bt = e
}

function zt(e, t) {
  let n = {};
  Ke(n, e);
  let i = [n, ...B(e)],
    c = typeof t == "function" ? Wr(i, t) : _r(i, t, e);
  return lr.bind(null, e, t, c)
}

function Wr(e, t) {
  return (n = () => {}, {
    scope: i = {},
    params: c = [],
    context: o
  } = {}) => {
    let r = t.apply(ae([i, ...e]), c);
    he(n, r)
  }
}
var Re = {};

function pr(e, t) {
  if (Re[e]) return Re[e];
  let n = Object.getPrototypeOf(async function() {})
    .constructor,
    i = /^[\n\s]*if.*\(.*\)/.test(e.trim()) || /^(let|const)\s/.test(e.trim()) ? `(async()=>{ ${e} })()` : e,
    o = (() => {
      try {
        let r = new n(["__self", "scope"], `with (scope) { __self.result = ${i} }; __self.finished = true; return __self.result;`);
        return Object.defineProperty(r, "name", {
          value: `[Alpine] ${e}`
        }), r
      } catch (r) {
        return oe(r, t, e), Promise.resolve()
      }
    })();
  return Re[e] = o, o
}

function _r(e, t, n) {
  let i = pr(t, n);
  return (c = () => {}, {
    scope: o = {},
    params: r = [],
    context: a
  } = {}) => {
    i.result = void 0, i.finished = !1;
    let s = ae([o, ...e]);
    if (typeof i == "function") {
      let u = i.call(a, i, s)
        .catch(d => oe(d, n, t));
      i.finished ? (he(c, i.result, s, r, n), i.result = void 0) : u.then(d => {
          he(c, d, s, r, n)
        })
        .catch(d => oe(d, n, t))
        .finally(() => i.result = void 0)
    }
  }
}

function he(e, t, n, i, c) {
  if (We && typeof t == "function") {
    let o = t.apply(n, i);
    o instanceof Promise ? o.then(r => he(e, r, n, i))
      .catch(r => oe(r, c, t)) : e(o)
  } else typeof t == "object" && t instanceof Promise ? t.then(o => e(o)) : e(t)
}
var nt = "x-";

function U(e = "") {
  return nt + e
}

function hr(e) {
  nt = e
}
var me = {};

function y(e, t) {
  return me[e] = t, {
    before(n) {
      if (!me[n]) {
        console.warn(String.raw`Cannot find directive \`${n}\`. \`${e}\` will use the default order of execution`);
        return
      }
      const i = M.indexOf(n);
      M.splice(i >= 0 ? i : M.indexOf("DEFAULT"), 0, e)
    }
  }
}

function mr(e) {
  return Object.keys(me)
    .includes(e)
}

function rt(e, t, n) {
  if (t = Array.from(t), e._x_virtualDirectives) {
    let o = Object.entries(e._x_virtualDirectives)
      .map(([a, s]) => ({
        name: a,
        value: s
      })),
      r = Vt(o);
    o = o.map(a => r.find(s => s.name === a.name) ? {
      name: `x-bind:${a.name}`,
      value: `"${a.value}"`
    } : a), t = t.concat(o)
  }
  let i = {};
  return t.map(Yt((o, r) => i[o] = r))
    .filter(tn)
    .map(Sr(i, n))
    .sort(br)
    .map(o => kr(e, o))
}

function Vt(e) {
  return Array.from(e)
    .map(Yt())
    .filter(t => !tn(t))
}
var Me = !1,
  ne = new Map,
  $t = Symbol();

function gr(e) {
  Me = !0;
  let t = Symbol();
  $t = t, ne.set(t, []);
  let n = () => {
      for (; ne.get(t)
        .length;) ne.get(t)
        .shift()();
      ne.delete(t)
    },
    i = () => {
      Me = !1, n()
    };
  e(n), i()
}

function Ut(e) {
  let t = [],
    n = a => t.push(a),
    [i, c] = nr(e);
  return t.push(c), [{
    Alpine: se,
    effect: i,
    cleanup: n,
    evaluateLater: O.bind(O, e),
    evaluate: G.bind(G, e)
  }, () => t.forEach(a => a())]
}

function kr(e, t) {
  let n = () => {},
    i = me[t.type] || n,
    [c, o] = Ut(e);
  Kt(e, t.original, o);
  let r = () => {
    e._x_ignore || e._x_ignoreSelf || (i.inline && i.inline(e, t, c), i = i.bind(i, e, t, c), Me ? ne.get($t)
      .push(i) : i())
  };
  return r.runCleanups = o, r
}
var Xt = (e, t) => ({
    name: n,
    value: i
  }) => (n.startsWith(e) && (n = n.replace(e, t)), {
    name: n,
    value: i
  }),
  Zt = e => e;

function Yt(e = () => {}) {
  return ({
    name: t,
    value: n
  }) => {
    let {
      name: i,
      value: c
    } = en.reduce((o, r) => r(o), {
      name: t,
      value: n
    });
    return i !== t && e(i, t), {
      name: i,
      value: c
    }
  }
}
var en = [];

function it(e) {
  en.push(e)
}

function tn({
  name: e
}) {
  return nn()
    .test(e)
}
var nn = () => new RegExp(`^${nt}([^:^.]+)\\b`);

function Sr(e, t) {
  return ({
    name: n,
    value: i
  }) => {
    let c = n.match(nn()),
      o = n.match(/:([a-zA-Z0-9\-_:]+)/),
      r = n.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
      a = t || e[n] || n;
    return {
      type: c ? c[1] : null,
      value: o ? o[1] : null,
      modifiers: r.map(s => s.replace(".", "")),
      expression: i,
      original: a
    }
  }
}
var je = "DEFAULT",
  M = ["ignore", "ref", "data", "id", "anchor", "bind", "init", "for", "model", "modelable", "transition", "show", "if", je, "teleport"];

function br(e, t) {
  let n = M.indexOf(e.type) === -1 ? je : e.type,
    i = M.indexOf(t.type) === -1 ? je : t.type;
  return M.indexOf(n) - M.indexOf(i)
}

function re(e, t, n = {}) {
  e.dispatchEvent(new CustomEvent(t, {
    detail: n,
    bubbles: !0,
    composed: !0,
    cancelable: !0
  }))
}

function D(e, t) {
  if (typeof ShadowRoot == "function" && e instanceof ShadowRoot) {
    Array.from(e.children)
      .forEach(c => D(c, t));
    return
  }
  let n = !1;
  if (t(e, () => n = !0), n) return;
  let i = e.firstElementChild;
  for (; i;) D(i, t), i = i.nextElementSibling
}

function v(e, ...t) {
  console.warn(`Alpine Warning: ${e}`, ...t)
}
var gt = !1;

function yr() {
  gt && v("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."), gt = !0, document.body || v("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"), re(document, "alpine:init"), re(document, "alpine:initializing"), Ye(), rr(t => L(t, D)), Ue(t => Z(t)), Jt((t, n) => {
    rt(t, n)
      .forEach(i => i())
  });
  let e = t => !Se(t.parentElement, !0);
  Array.from(document.querySelectorAll(cn()
      .join(",")))
    .filter(e)
    .forEach(t => {
      L(t)
    }), re(document, "alpine:initialized"), setTimeout(() => {
      wr()
    })
}
var ot = [],
  rn = [];

function on() {
  return ot.map(e => e())
}

function cn() {
  return ot.concat(rn)
    .map(e => e())
}

function an(e) {
  ot.push(e)
}

function sn(e) {
  rn.push(e)
}

function Se(e, t = !1) {
  return X(e, n => {
    if ((t ? cn() : on())
      .some(c => n.matches(c))) return !0
  })
}

function X(e, t) {
  if (e) {
    if (t(e)) return e;
    if (e._x_teleportBack && (e = e._x_teleportBack), !!e.parentElement) return X(e.parentElement, t)
  }
}

function Or(e) {
  return on()
    .some(t => e.matches(t))
}
var un = [];

function Cr(e) {
  un.push(e)
}
var vr = 1;

function L(e, t = D, n = () => {}) {
  X(e, i => i._x_ignore) || gr(() => {
    t(e, (i, c) => {
      i._x_marker || (n(i, c), un.forEach(o => o(i, c)), rt(i, i.attributes)
        .forEach(o => o()), i._x_ignore || (i._x_marker = vr++), i._x_ignore && c())
    })
  })
}

function Z(e, t = D) {
  t(e, n => {
    ir(n), Mt(n), delete n._x_marker
  })
}

function wr() {
  [
    ["ui", "dialog", ["[x-dialog], [x-popover]"]],
    ["anchor", "anchor", ["[x-anchor]"]],
    ["sort", "sort", ["[x-sort]"]]
  ].forEach(([t, n, i]) => {
    mr(n) || i.some(c => {
      if (document.querySelector(c)) return v(`found "${c}", but missing ${t} plugin`), !0
    })
  })
}
var Ge = [],
  ct = !1;

function at(e = () => {}) {
  return queueMicrotask(() => {
    ct || setTimeout(() => {
      He()
    })
  }), new Promise(t => {
    Ge.push(() => {
      e(), t()
    })
  })
}

function He() {
  for (ct = !1; Ge.length;) Ge.shift()()
}

function Rr() {
  ct = !0
}

function st(e, t) {
  return Array.isArray(t) ? kt(e, t.join(" ")) : typeof t == "object" && t !== null ? Er(e, t) : typeof t == "function" ? st(e, t()) : kt(e, t)
}

function kt(e, t) {
  let n = c => c.split(" ")
    .filter(o => !e.classList.contains(o))
    .filter(Boolean),
    i = c => (e.classList.add(...c), () => {
      e.classList.remove(...c)
    });
  return t = t === !0 ? t = "" : t || "", i(n(t))
}

function Er(e, t) {
  let n = a => a.split(" ")
    .filter(Boolean),
    i = Object.entries(t)
    .flatMap(([a, s]) => s ? n(a) : !1)
    .filter(Boolean),
    c = Object.entries(t)
    .flatMap(([a, s]) => s ? !1 : n(a))
    .filter(Boolean),
    o = [],
    r = [];
  return c.forEach(a => {
    e.classList.contains(a) && (e.classList.remove(a), r.push(a))
  }), i.forEach(a => {
    e.classList.contains(a) || (e.classList.add(a), o.push(a))
  }), () => {
    r.forEach(a => e.classList.add(a)), o.forEach(a => e.classList.remove(a))
  }
}

function be(e, t) {
  return typeof t == "object" && t !== null ? Pr(e, t) : Ar(e, t)
}

function Pr(e, t) {
  let n = {};
  return Object.entries(t)
    .forEach(([i, c]) => {
      n[i] = e.style[i], i.startsWith("--") || (i = Lr(i)), e.style.setProperty(i, c)
    }), setTimeout(() => {
      e.style.length === 0 && e.removeAttribute("style")
    }), () => {
      be(e, n)
    }
}

function Ar(e, t) {
  let n = e.getAttribute("style", t);
  return e.setAttribute("style", t), () => {
    e.setAttribute("style", n || "")
  }
}

function Lr(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2")
    .toLowerCase()
}

function Qe(e, t = () => {}) {
  let n = !1;
  return function() {
    n ? t.apply(this, arguments) : (n = !0, e.apply(this, arguments))
  }
}
y("transition", (e, {
  value: t,
  modifiers: n,
  expression: i
}, {
  evaluate: c
}) => {
  typeof i == "function" && (i = c(i)), i !== !1 && (!i || typeof i == "boolean" ? Nr(e, n, t) : Tr(e, i, t))
});

function Tr(e, t, n) {
  fn(e, st, ""), {
    enter: c => {
      e._x_transition.enter.during = c
    },
    "enter-start": c => {
      e._x_transition.enter.start = c
    },
    "enter-end": c => {
      e._x_transition.enter.end = c
    },
    leave: c => {
      e._x_transition.leave.during = c
    },
    "leave-start": c => {
      e._x_transition.leave.start = c
    },
    "leave-end": c => {
      e._x_transition.leave.end = c
    }
  } [n](t)
}

function Nr(e, t, n) {
  fn(e, be);
  let i = !t.includes("in") && !t.includes("out") && !n,
    c = i || t.includes("in") || ["enter"].includes(n),
    o = i || t.includes("out") || ["leave"].includes(n);
  t.includes("in") && !i && (t = t.filter((W, m) => m < t.indexOf("out"))), t.includes("out") && !i && (t = t.filter((W, m) => m > t.indexOf("out")));
  let r = !t.includes("opacity") && !t.includes("scale"),
    a = r || t.includes("opacity"),
    s = r || t.includes("scale"),
    u = a ? 0 : 1,
    d = s ? ee(t, "scale", 95) / 100 : 1,
    p = ee(t, "delay", 0) / 1e3,
    h = ee(t, "origin", "center"),
    _ = "opacity, transform",
    f = ee(t, "duration", 150) / 1e3,
    l = ee(t, "duration", 75) / 1e3,
    x = "cubic-bezier(0.4, 0.0, 0.2, 1)";
  c && (e._x_transition.enter.during = {
    transformOrigin: h,
    transitionDelay: `${p}s`,
    transitionProperty: _,
    transitionDuration: `${f}s`,
    transitionTimingFunction: x
  }, e._x_transition.enter.start = {
    opacity: u,
    transform: `scale(${d})`
  }, e._x_transition.enter.end = {
    opacity: 1,
    transform: "scale(1)"
  }), o && (e._x_transition.leave.during = {
    transformOrigin: h,
    transitionDelay: `${p}s`,
    transitionProperty: _,
    transitionDuration: `${l}s`,
    transitionTimingFunction: x
  }, e._x_transition.leave.start = {
    opacity: 1,
    transform: "scale(1)"
  }, e._x_transition.leave.end = {
    opacity: u,
    transform: `scale(${d})`
  })
}

function fn(e, t, n = {}) {
  e._x_transition || (e._x_transition = {
    enter: {
      during: n,
      start: n,
      end: n
    },
    leave: {
      during: n,
      start: n,
      end: n
    },
    in(i = () => {}, c = () => {}) {
      De(e, t, {
        during: this.enter.during,
        start: this.enter.start,
        end: this.enter.end
      }, i, c)
    },
    out(i = () => {}, c = () => {}) {
      De(e, t, {
        during: this.leave.during,
        start: this.leave.start,
        end: this.leave.end
      }, i, c)
    }
  })
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(e, t, n, i) {
  const c = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
  let o = () => c(n);
  if (t) {
    e._x_transition && (e._x_transition.enter || e._x_transition.leave) ? e._x_transition.enter && (Object.entries(e._x_transition.enter.during)
      .length || Object.entries(e._x_transition.enter.start)
      .length || Object.entries(e._x_transition.enter.end)
      .length) ? e._x_transition.in(n) : o() : e._x_transition ? e._x_transition.in(n) : o();
    return
  }
  e._x_hidePromise = e._x_transition ? new Promise((r, a) => {
    e._x_transition.out(() => {}, () => r(i)), e._x_transitioning && e._x_transitioning.beforeCancel(() => a({
      isFromCancelledTransition: !0
    }))
  }) : Promise.resolve(i), queueMicrotask(() => {
    let r = dn(e);
    r ? (r._x_hideChildren || (r._x_hideChildren = []), r._x_hideChildren.push(e)) : c(() => {
      let a = s => {
        let u = Promise.all([s._x_hidePromise, ...(s._x_hideChildren || [])
            .map(a)
          ])
          .then(([d]) => d?.());
        return delete s._x_hidePromise, delete s._x_hideChildren, u
      };
      a(e)
        .catch(s => {
          if (!s.isFromCancelledTransition) throw s
        })
    })
  })
};

function dn(e) {
  let t = e.parentNode;
  if (t) return t._x_hidePromise ? t : dn(t)
}

function De(e, t, {
  during: n,
  start: i,
  end: c
} = {}, o = () => {}, r = () => {}) {
  if (e._x_transitioning && e._x_transitioning.cancel(), Object.keys(n)
    .length === 0 && Object.keys(i)
    .length === 0 && Object.keys(c)
    .length === 0) {
    o(), r();
    return
  }
  let a, s, u;
  qr(e, {
    start() {
      a = t(e, i)
    },
    during() {
      s = t(e, n)
    },
    before: o,
    end() {
      a(), u = t(e, c)
    },
    after: r,
    cleanup() {
      s(), u()
    }
  })
}

function qr(e, t) {
  let n, i, c, o = Qe(() => {
    S(() => {
      n = !0, i || t.before(), c || (t.end(), He()), t.after(), e.isConnected && t.cleanup(), delete e._x_transitioning
    })
  });
  e._x_transitioning = {
    beforeCancels: [],
    beforeCancel(r) {
      this.beforeCancels.push(r)
    },
    cancel: Qe(function() {
      for (; this.beforeCancels.length;) this.beforeCancels.shift()();
      o()
    }),
    finish: o
  }, S(() => {
    t.start(), t.during()
  }), Rr(), requestAnimationFrame(() => {
    if (n) return;
    let r = Number(getComputedStyle(e)
        .transitionDuration.replace(/,.*/, "")
        .replace("s", "")) * 1e3,
      a = Number(getComputedStyle(e)
        .transitionDelay.replace(/,.*/, "")
        .replace("s", "")) * 1e3;
    r === 0 && (r = Number(getComputedStyle(e)
      .animationDuration.replace("s", "")) * 1e3), S(() => {
      t.before()
    }), i = !0, requestAnimationFrame(() => {
      n || (S(() => {
        t.end()
      }), He(), setTimeout(e._x_transitioning.finish, r + a), c = !0)
    })
  })
}

function ee(e, t, n) {
  if (e.indexOf(t) === -1) return n;
  const i = e[e.indexOf(t) + 1];
  if (!i || t === "scale" && isNaN(i)) return n;
  if (t === "duration" || t === "delay") {
    let c = i.match(/([0-9]+)ms/);
    if (c) return c[1]
  }
  return t === "origin" && ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2]) ? [i, e[e.indexOf(t) + 2]].join(" ") : i
}
var q = !1;

function J(e, t = () => {}) {
  return (...n) => q ? t(...n) : e(...n)
}

function Ir(e) {
  return (...t) => q && e(...t)
}
var ln = [];

function ye(e) {
  ln.push(e)
}

function Jr(e, t) {
  ln.forEach(n => n(e, t)), q = !0, xn(() => {
    L(t, (n, i) => {
      i(n, () => {})
    })
  }), q = !1
}
var Fe = !1;

function Kr(e, t) {
  t._x_dataStack || (t._x_dataStack = e._x_dataStack), q = !0, Fe = !0, xn(() => {
    Mr(t)
  }), q = !1, Fe = !1
}

function Mr(e) {
  let t = !1;
  L(e, (i, c) => {
    D(i, (o, r) => {
      if (t && Or(o)) return r();
      t = !0, c(o, r)
    })
  })
}

function xn(e) {
  let t = F;
  mt((n, i) => {
    let c = t(n);
    return $(c), () => {}
  }), e(), mt(t)
}

function Wn(e, t, n, i = []) {
  switch (e._x_bindings || (e._x_bindings = V({})), e._x_bindings[t] = n, t = i.includes("camel") ? zr(t) : t, t) {
    case "value":
      jr(e, n);
      break;
    case "style":
      Hr(e, n);
      break;
    case "class":
      Gr(e, n);
      break;
    case "selected":
    case "checked":
      Qr(e, t, n);
      break;
    default:
      pn(e, t, n);
      break
  }
}

function jr(e, t) {
  if (mn(e)) e.attributes.value === void 0 && (e.value = t), window.fromModel && (typeof t == "boolean" ? e.checked = pe(e.value) === t : e.checked = St(e.value, t));
  else if (ut(e)) Number.isInteger(t) ? e.value = t : !Array.isArray(t) && typeof t != "boolean" && ![null, void 0].includes(t) ? e.value = String(t) : Array.isArray(t) ? e.checked = t.some(n => St(n, e.value)) : e.checked = !!t;
  else if (e.tagName === "SELECT") Br(e, t);
  else {
    if (e.value === t) return;
    e.value = t === void 0 ? "" : t
  }
}

function Gr(e, t) {
  e._x_undoAddedClasses && e._x_undoAddedClasses(), e._x_undoAddedClasses = st(e, t)
}

function Hr(e, t) {
  e._x_undoAddedStyles && e._x_undoAddedStyles(), e._x_undoAddedStyles = be(e, t)
}

function Qr(e, t, n) {
  pn(e, t, n), Fr(e, t, n)
}

function pn(e, t, n) {
  [null, void 0, !1].includes(n) && $r(t) ? e.removeAttribute(t) : (_n(t) && (n = t), Dr(e, t, n))
}

function Dr(e, t, n) {
  e.getAttribute(t) != n && e.setAttribute(t, n)
}

function Fr(e, t, n) {
  e[t] !== n && (e[t] = n)
}

function Br(e, t) {
  const n = [].concat(t)
    .map(i => i + "");
  Array.from(e.options)
    .forEach(i => {
      i.selected = n.includes(i.value)
    })
}

function zr(e) {
  return e.toLowerCase()
    .replace(/-(\w)/g, (t, n) => n.toUpperCase())
}

function St(e, t) {
  return e == t
}

function pe(e) {
  return [1, "1", "true", "on", "yes", !0].includes(e) ? !0 : [0, "0", "false", "off", "no", !1].includes(e) ? !1 : e ? !!e : null
}
var Vr = new Set(["allowfullscreen", "async", "autofocus", "autoplay", "checked", "controls", "default", "defer", "disabled", "formnovalidate", "inert", "ismap", "itemscope", "loop", "multiple", "muted", "nomodule", "novalidate", "open", "playsinline", "readonly", "required", "reversed", "selected", "shadowrootclonable", "shadowrootdelegatesfocus", "shadowrootserializable"]);

function _n(e) {
  return Vr.has(e)
}

function $r(e) {
  return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(e)
}

function Ur(e, t, n) {
  return e._x_bindings && e._x_bindings[t] !== void 0 ? e._x_bindings[t] : hn(e, t, n)
}

function Xr(e, t, n, i = !0) {
  if (e._x_bindings && e._x_bindings[t] !== void 0) return e._x_bindings[t];
  if (e._x_inlineBindings && e._x_inlineBindings[t] !== void 0) {
    let c = e._x_inlineBindings[t];
    return c.extract = i, Ft(() => G(e, c.expression))
  }
  return hn(e, t, n)
}

function hn(e, t, n) {
  let i = e.getAttribute(t);
  return i === null ? typeof n == "function" ? n() : n : i === "" ? !0 : _n(t) ? !![t, "true"].includes(i) : i
}

function ut(e) {
  return e.type === "checkbox" || e.localName === "ui-checkbox" || e.localName === "ui-switch"
}

function mn(e) {
  return e.type === "radio" || e.localName === "ui-radio"
}

function gn(e, t) {
  let n;
  return function() {
    const i = this,
      c = arguments,
      o = function() {
        n = null, e.apply(i, c)
      };
    clearTimeout(n), n = setTimeout(o, t)
  }
}

function kn(e, t) {
  let n;
  return function() {
    let i = this,
      c = arguments;
    n || (e.apply(i, c), n = !0, setTimeout(() => n = !1, t))
  }
}

function Sn({
  get: e,
  set: t
}, {
  get: n,
  set: i
}) {
  let c = !0,
    o, r = F(() => {
      let a = e(),
        s = n();
      if (c) i(Ee(a)), c = !1;
      else {
        let u = JSON.stringify(a),
          d = JSON.stringify(s);
        u !== o ? i(Ee(a)) : u !== d && t(Ee(s))
      }
      o = JSON.stringify(e()), JSON.stringify(n())
    });
  return () => {
    $(r)
  }
}

function Ee(e) {
  return typeof e == "object" ? JSON.parse(JSON.stringify(e)) : e
}

function Zr(e) {
  (Array.isArray(e) ? e : [e])
  .forEach(n => n(se))
}
var K = {},
  bt = !1;

function Yr(e, t) {
  if (bt || (K = V(K), bt = !0), t === void 0) return K[e];
  K[e] = t, Ht(K[e]), typeof t == "object" && t !== null && t.hasOwnProperty("init") && typeof t.init == "function" && K[e].init()
}

function ei() {
  return K
}
var bn = {};

function ti(e, t) {
  let n = typeof t != "function" ? () => t : t;
  return e instanceof Element ? yn(e, n()) : (bn[e] = n, () => {})
}

function ni(e) {
  return Object.entries(bn)
    .forEach(([t, n]) => {
      Object.defineProperty(e, t, {
        get() {
          return (...i) => n(...i)
        }
      })
    }), e
}

function yn(e, t, n) {
  let i = [];
  for (; i.length;) i.pop()();
  let c = Object.entries(t)
    .map(([r, a]) => ({
      name: r,
      value: a
    })),
    o = Vt(c);
  return c = c.map(r => o.find(a => a.name === r.name) ? {
      name: `x-bind:${r.name}`,
      value: `"${r.value}"`
    } : r), rt(e, c, n)
    .map(r => {
      i.push(r.runCleanups), r()
    }), () => {
      for (; i.length;) i.pop()()
    }
}
var On = {};

function ri(e, t) {
  On[e] = t
}

function ii(e, t) {
  return Object.entries(On)
    .forEach(([n, i]) => {
      Object.defineProperty(e, n, {
        get() {
          return (...c) => i.bind(t)(...c)
        },
        enumerable: !1
      })
    }), e
}
var oi = {
    get reactive() {
      return V
    },
    get release() {
      return $
    },
    get effect() {
      return F
    },
    get raw() {
      return Lt
    },
    version: "3.15.0",
    flushAndStopDeferringMutations: ar,
    dontAutoEvaluateFunctions: Ft,
    disableEffectScheduling: er,
    startObservingMutations: Ye,
    stopObservingMutations: jt,
    setReactivityEngine: tr,
    onAttributeRemoved: Kt,
    onAttributesAdded: Jt,
    closestDataStack: B,
    skipDuringClone: J,
    onlyDuringClone: Ir,
    addRootSelector: an,
    addInitSelector: sn,
    interceptClone: ye,
    addScopeToNode: ce,
    deferMutations: cr,
    mapAttributes: it,
    evaluateLater: O,
    interceptInit: Cr,
    setEvaluator: xr,
    mergeProxies: ae,
    extractProp: Xr,
    findClosest: X,
    onElRemoved: Ue,
    closestRoot: Se,
    destroyTree: Z,
    interceptor: Qt,
    transition: De,
    setStyles: be,
    mutateDom: S,
    directive: y,
    entangle: Sn,
    throttle: kn,
    debounce: gn,
    evaluate: G,
    initTree: L,
    nextTick: at,
    prefixed: U,
    prefix: hr,
    plugin: Zr,
    magic: E,
    store: Yr,
    start: yr,
    clone: Kr,
    cloneNode: Jr,
    bound: Ur,
    $data: Gt,
    watch: Tt,
    walk: D,
    data: ri,
    bind: ti
  },
  se = oi;

function ci(e, t) {
  const n = Object.create(null),
    i = e.split(",");
  for (let c = 0; c < i.length; c++) n[i[c]] = !0;
  return c => !!n[c]
}
var ai = Object.freeze({}),
  si = Object.prototype.hasOwnProperty,
  Oe = (e, t) => si.call(e, t),
  H = Array.isArray,
  ie = e => Cn(e) === "[object Map]",
  ui = e => typeof e == "string",
  ft = e => typeof e == "symbol",
  Ce = e => e !== null && typeof e == "object",
  fi = Object.prototype.toString,
  Cn = e => fi.call(e),
  vn = e => Cn(e)
  .slice(8, -1),
  dt = e => ui(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e,
  di = e => {
    const t = Object.create(null);
    return n => t[n] || (t[n] = e(n))
  },
  li = di(e => e.charAt(0)
    .toUpperCase() + e.slice(1)),
  wn = (e, t) => e !== t && (e === e || t === t),
  Be = new WeakMap,
  te = [],
  A, Q = Symbol("iterate"),
  ze = Symbol("Map key iterate");

function xi(e) {
  return e && e._isEffect === !0
}

function Wi(e, t = ai) {
  xi(e) && (e = e.raw);
  const n = hi(e, t);
  return t.lazy || n(), n
}

function pi(e) {
  e.active && (Rn(e), e.options.onStop && e.options.onStop(), e.active = !1)
}
var _i = 0;

function hi(e, t) {
  const n = function() {
    if (!n.active) return e();
    if (!te.includes(n)) {
      Rn(n);
      try {
        return gi(), te.push(n), A = n, e()
      } finally {
        te.pop(), En(), A = te[te.length - 1]
      }
    }
  };
  return n.id = _i++, n.allowRecurse = !!t.allowRecurse, n._isEffect = !0, n.active = !0, n.raw = e, n.deps = [], n.options = t, n
}

function Rn(e) {
  const {
    deps: t
  } = e;
  if (t.length) {
    for (let n = 0; n < t.length; n++) t[n].delete(e);
    t.length = 0
  }
}
var z = !0,
  lt = [];

function mi() {
  lt.push(z), z = !1
}

function gi() {
  lt.push(z), z = !0
}

function En() {
  const e = lt.pop();
  z = e === void 0 ? !0 : e
}

function R(e, t, n) {
  if (!z || A === void 0) return;
  let i = Be.get(e);
  i || Be.set(e, i = new Map);
  let c = i.get(n);
  c || i.set(n, c = new Set), c.has(A) || (c.add(A), A.deps.push(c), A.options.onTrack && A.options.onTrack({
    effect: A,
    target: e,
    type: t,
    key: n
  }))
}

function I(e, t, n, i, c, o) {
  const r = Be.get(e);
  if (!r) return;
  const a = new Set,
    s = d => {
      d && d.forEach(p => {
        (p !== A || p.allowRecurse) && a.add(p)
      })
    };
  if (t === "clear") r.forEach(s);
  else if (n === "length" && H(e)) r.forEach((d, p) => {
    (p === "length" || p >= i) && s(d)
  });
  else switch (n !== void 0 && s(r.get(n)), t) {
    case "add":
      H(e) ? dt(n) && s(r.get("length")) : (s(r.get(Q)), ie(e) && s(r.get(ze)));
      break;
    case "delete":
      H(e) || (s(r.get(Q)), ie(e) && s(r.get(ze)));
      break;
    case "set":
      ie(e) && s(r.get(Q));
      break
  }
  const u = d => {
    d.options.onTrigger && d.options.onTrigger({
      effect: d,
      target: e,
      key: n,
      type: t,
      newValue: i,
      oldValue: c,
      oldTarget: o
    }), d.options.scheduler ? d.options.scheduler(d) : d()
  };
  a.forEach(u)
}
var ki = ci("__proto__,__v_isRef,__isVue"),
  Pn = new Set(Object.getOwnPropertyNames(Symbol)
    .map(e => Symbol[e])
    .filter(ft)),
  Si = An(),
  bi = An(!0),
  yt = yi();

function yi() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach(t => {
    e[t] = function(...n) {
      const i = k(this);
      for (let o = 0, r = this.length; o < r; o++) R(i, "get", o + "");
      const c = i[t](...n);
      return c === -1 || c === !1 ? i[t](...n.map(k)) : c
    }
  }), ["push", "pop", "shift", "unshift", "splice"].forEach(t => {
    e[t] = function(...n) {
      mi();
      const i = k(this)[t].apply(this, n);
      return En(), i
    }
  }), e
}

function An(e = !1, t = !1) {
  return function(i, c, o) {
    if (c === "__v_isReactive") return !e;
    if (c === "__v_isReadonly") return e;
    if (c === "__v_raw" && o === (e ? t ? Ji : qn : t ? Ii : Nn)
      .get(i)) return i;
    const r = H(i);
    if (!e && r && Oe(yt, c)) return Reflect.get(yt, c, o);
    const a = Reflect.get(i, c, o);
    return (ft(c) ? Pn.has(c) : ki(c)) || (e || R(i, "get", c), t) ? a : Ve(a) ? !r || !dt(c) ? a.value : a : Ce(a) ? e ? In(a) : _t(a) : a
  }
}
var Oi = Ci();

function Ci(e = !1) {
  return function(n, i, c, o) {
    let r = n[i];
    if (!e && (c = k(c), r = k(r), !H(n) && Ve(r) && !Ve(c))) return r.value = c, !0;
    const a = H(n) && dt(i) ? Number(i) < n.length : Oe(n, i),
      s = Reflect.set(n, i, c, o);
    return n === k(o) && (a ? wn(c, r) && I(n, "set", i, c, r) : I(n, "add", i, c)), s
  }
}

function vi(e, t) {
  const n = Oe(e, t),
    i = e[t],
    c = Reflect.deleteProperty(e, t);
  return c && n && I(e, "delete", t, void 0, i), c
}

function wi(e, t) {
  const n = Reflect.has(e, t);
  return (!ft(t) || !Pn.has(t)) && R(e, "has", t), n
}

function Ri(e) {
  return R(e, "iterate", H(e) ? "length" : Q), Reflect.ownKeys(e)
}
var Ei = {
    get: Si,
    set: Oi,
    deleteProperty: vi,
    has: wi,
    ownKeys: Ri
  },
  Pi = {
    get: bi,
    set(e, t) {
      return console.warn(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0
    },
    deleteProperty(e, t) {
      return console.warn(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0
    }
  },
  xt = e => Ce(e) ? _t(e) : e,
  Wt = e => Ce(e) ? In(e) : e,
  pt = e => e,
  ve = e => Reflect.getPrototypeOf(e);

function ue(e, t, n = !1, i = !1) {
  e = e.__v_raw;
  const c = k(e),
    o = k(t);
  t !== o && !n && R(c, "get", t), !n && R(c, "get", o);
  const {
    has: r
  } = ve(c), a = i ? pt : n ? Wt : xt;
  if (r.call(c, t)) return a(e.get(t));
  if (r.call(c, o)) return a(e.get(o));
  e !== c && e.get(t)
}

function fe(e, t = !1) {
  const n = this.__v_raw,
    i = k(n),
    c = k(e);
  return e !== c && !t && R(i, "has", e), !t && R(i, "has", c), e === c ? n.has(e) : n.has(e) || n.has(c)
}

function de(e, t = !1) {
  return e = e.__v_raw, !t && R(k(e), "iterate", Q), Reflect.get(e, "size", e)
}

function Ot(e) {
  e = k(e);
  const t = k(this);
  return ve(t)
    .has.call(t, e) || (t.add(e), I(t, "add", e, e)), this
}

function Ct(e, t) {
  t = k(t);
  const n = k(this),
    {
      has: i,
      get: c
    } = ve(n);
  let o = i.call(n, e);
  o ? Tn(n, i, e) : (e = k(e), o = i.call(n, e));
  const r = c.call(n, e);
  return n.set(e, t), o ? wn(t, r) && I(n, "set", e, t, r) : I(n, "add", e, t), this
}

function vt(e) {
  const t = k(this),
    {
      has: n,
      get: i
    } = ve(t);
  let c = n.call(t, e);
  c ? Tn(t, n, e) : (e = k(e), c = n.call(t, e));
  const o = i ? i.call(t, e) : void 0,
    r = t.delete(e);
  return c && I(t, "delete", e, void 0, o), r
}

function wt() {
  const e = k(this),
    t = e.size !== 0,
    n = ie(e) ? new Map(e) : new Set(e),
    i = e.clear();
  return t && I(e, "clear", void 0, void 0, n), i
}

function le(e, t) {
  return function(i, c) {
    const o = this,
      r = o.__v_raw,
      a = k(r),
      s = t ? pt : e ? Wt : xt;
    return !e && R(a, "iterate", Q), r.forEach((u, d) => i.call(c, s(u), s(d), o))
  }
}

function xe(e, t, n) {
  return function(...i) {
    const c = this.__v_raw,
      o = k(c),
      r = ie(o),
      a = e === "entries" || e === Symbol.iterator && r,
      s = e === "keys" && r,
      u = c[e](...i),
      d = n ? pt : t ? Wt : xt;
    return !t && R(o, "iterate", s ? ze : Q), {
      next() {
        const {
          value: p,
          done: h
        } = u.next();
        return h ? {
          value: p,
          done: h
        } : {
          value: a ? [d(p[0]), d(p[1])] : d(p),
          done: h
        }
      },
      [Symbol.iterator]() {
        return this
      }
    }
  }
}

function N(e) {
  return function(...t) {
    {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      console.warn(`${li(e)} operation ${n}failed: target is readonly.`, k(this))
    }
    return e === "delete" ? !1 : this
  }
}

function Ai() {
  const e = {
      get(o) {
        return ue(this, o)
      },
      get size() {
        return de(this)
      },
      has: fe,
      add: Ot,
      set: Ct,
      delete: vt,
      clear: wt,
      forEach: le(!1, !1)
    },
    t = {
      get(o) {
        return ue(this, o, !1, !0)
      },
      get size() {
        return de(this)
      },
      has: fe,
      add: Ot,
      set: Ct,
      delete: vt,
      clear: wt,
      forEach: le(!1, !0)
    },
    n = {
      get(o) {
        return ue(this, o, !0)
      },
      get size() {
        return de(this, !0)
      },
      has(o) {
        return fe.call(this, o, !0)
      },
      add: N("add"),
      set: N("set"),
      delete: N("delete"),
      clear: N("clear"),
      forEach: le(!0, !1)
    },
    i = {
      get(o) {
        return ue(this, o, !0, !0)
      },
      get size() {
        return de(this, !0)
      },
      has(o) {
        return fe.call(this, o, !0)
      },
      add: N("add"),
      set: N("set"),
      delete: N("delete"),
      clear: N("clear"),
      forEach: le(!0, !0)
    };
  return ["keys", "values", "entries", Symbol.iterator].forEach(o => {
    e[o] = xe(o, !1, !1), n[o] = xe(o, !0, !1), t[o] = xe(o, !1, !0), i[o] = xe(o, !0, !0)
  }), [e, n, t, i]
}
var [Li, Ti] = Ai();

function Ln(e, t) {
  const n = e ? Ti : Li;
  return (i, c, o) => c === "__v_isReactive" ? !e : c === "__v_isReadonly" ? e : c === "__v_raw" ? i : Reflect.get(Oe(n, c) && c in i ? n : i, c, o)
}
var Ni = {
    get: Ln(!1)
  },
  qi = {
    get: Ln(!0)
  };

function Tn(e, t, n) {
  const i = k(n);
  if (i !== n && t.call(e, i)) {
    const c = vn(e);
    console.warn(`Reactive ${c} contains both the raw and reactive versions of the same object${c==="Map"?" as keys":""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`)
  }
}
var Nn = new WeakMap,
  Ii = new WeakMap,
  qn = new WeakMap,
  Ji = new WeakMap;

function Ki(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0
  }
}

function Mi(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Ki(vn(e))
}

function _t(e) {
  return e && e.__v_isReadonly ? e : Jn(e, !1, Ei, Ni, Nn)
}

function In(e) {
  return Jn(e, !0, Pi, qi, qn)
}

function Jn(e, t, n, i, c) {
  if (!Ce(e)) return console.warn(`value cannot be made reactive: ${String(e)}`), e;
  if (e.__v_raw && !(t && e.__v_isReactive)) return e;
  const o = c.get(e);
  if (o) return o;
  const r = Mi(e);
  if (r === 0) return e;
  const a = new Proxy(e, r === 2 ? i : n);
  return c.set(e, a), a
}

function k(e) {
  return e && k(e.__v_raw) || e
}

function Ve(e) {
  return !!(e && e.__v_isRef === !0)
}
E("nextTick", () => at);
E("dispatch", e => re.bind(re, e));
E("watch", (e, {
  evaluateLater: t,
  cleanup: n
}) => (i, c) => {
  let o = t(i),
    a = Tt(() => {
      let s;
      return o(u => s = u), s
    }, c);
  n(a)
});
E("store", ei);
E("data", e => Gt(e));
E("root", e => Se(e));
E("refs", e => (e._x_refs_proxy || (e._x_refs_proxy = ae(ji(e))), e._x_refs_proxy));

function ji(e) {
  let t = [];
  return X(e, n => {
    n._x_refs && t.push(n._x_refs)
  }), t
}
var Pe = {};

function Kn(e) {
  return Pe[e] || (Pe[e] = 0), ++Pe[e]
}

function Gi(e, t) {
  return X(e, n => {
    if (n._x_ids && n._x_ids[t]) return !0
  })
}

function Hi(e, t) {
  e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = Kn(t))
}
E("id", (e, {
  cleanup: t
}) => (n, i = null) => {
  let c = `${n}${i?`-${i}`:""}`;
  return Qi(e, c, t, () => {
    let o = Gi(e, n),
      r = o ? o._x_ids[n] : Kn(n);
    return i ? `${n}-${r}-${i}` : `${n}-${r}`
  })
});
ye((e, t) => {
  e._x_id && (t._x_id = e._x_id)
});

function Qi(e, t, n, i) {
  if (e._x_id || (e._x_id = {}), e._x_id[t]) return e._x_id[t];
  let c = i();
  return e._x_id[t] = c, n(() => {
    delete e._x_id[t]
  }), c
}
E("el", e => e);
Mn("Focus", "focus", "focus");
Mn("Persist", "persist", "persist");

function Mn(e, t, n) {
  E(t, i => v(`You can't use [$${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`, i))
}
y("modelable", (e, {
  expression: t
}, {
  effect: n,
  evaluateLater: i,
  cleanup: c
}) => {
  let o = i(t),
    r = () => {
      let d;
      return o(p => d = p), d
    },
    a = i(`${t} = __placeholder`),
    s = d => a(() => {}, {
      scope: {
        __placeholder: d
      }
    }),
    u = r();
  s(u), queueMicrotask(() => {
    if (!e._x_model) return;
    e._x_removeModelListeners.default();
    let d = e._x_model.get,
      p = e._x_model.set,
      h = Sn({
        get() {
          return d()
        },
        set(_) {
          p(_)
        }
      }, {
        get() {
          return r()
        },
        set(_) {
          s(_)
        }
      });
    c(h)
  })
});
y("teleport", (e, {
  modifiers: t,
  expression: n
}, {
  cleanup: i
}) => {
  e.tagName.toLowerCase() !== "template" && v("x-teleport can only be used on a <template> tag", e);
  let c = Rt(n),
    o = e.content.cloneNode(!0)
    .firstElementChild;
  e._x_teleport = o, o._x_teleportBack = e, e.setAttribute("data-teleport-template", !0), o.setAttribute("data-teleport-target", !0), e._x_forwardEvents && e._x_forwardEvents.forEach(a => {
    o.addEventListener(a, s => {
      s.stopPropagation(), e.dispatchEvent(new s.constructor(s.type, s))
    })
  }), ce(o, {}, e);
  let r = (a, s, u) => {
    u.includes("prepend") ? s.parentNode.insertBefore(a, s) : u.includes("append") ? s.parentNode.insertBefore(a, s.nextSibling) : s.appendChild(a)
  };
  S(() => {
    r(o, c, t), J(() => {
      L(o)
    })()
  }), e._x_teleportPutBack = () => {
    let a = Rt(n);
    S(() => {
      r(e._x_teleport, a, t)
    })
  }, i(() => S(() => {
    o.remove(), Z(o)
  }))
});
var Di = document.createElement("div");

function Rt(e) {
  let t = J(() => document.querySelector(e), () => Di)();
  return t || v(`Cannot find x-teleport element for selector: "${e}"`), t
}
var jn = () => {};
jn.inline = (e, {
  modifiers: t
}, {
  cleanup: n
}) => {
  t.includes("self") ? e._x_ignoreSelf = !0 : e._x_ignore = !0, n(() => {
    t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore
  })
};
y("ignore", jn);
y("effect", J((e, {
  expression: t
}, {
  effect: n
}) => {
  n(O(e, t))
}));

function $e(e, t, n, i) {
  let c = e,
    o = s => i(s),
    r = {},
    a = (s, u) => d => u(s, d);
  if (n.includes("dot") && (t = Fi(t)), n.includes("camel") && (t = Bi(t)), n.includes("passive") && (r.passive = !0), n.includes("capture") && (r.capture = !0), n.includes("window") && (c = window), n.includes("document") && (c = document), n.includes("debounce")) {
    let s = n[n.indexOf("debounce") + 1] || "invalid-wait",
      u = ge(s.split("ms")[0]) ? Number(s.split("ms")[0]) : 250;
    o = gn(o, u)
  }
  if (n.includes("throttle")) {
    let s = n[n.indexOf("throttle") + 1] || "invalid-wait",
      u = ge(s.split("ms")[0]) ? Number(s.split("ms")[0]) : 250;
    o = kn(o, u)
  }
  return n.includes("prevent") && (o = a(o, (s, u) => {
    u.preventDefault(), s(u)
  })), n.includes("stop") && (o = a(o, (s, u) => {
    u.stopPropagation(), s(u)
  })), n.includes("once") && (o = a(o, (s, u) => {
    s(u), c.removeEventListener(t, o, r)
  })), (n.includes("away") || n.includes("outside")) && (c = document, o = a(o, (s, u) => {
    e.contains(u.target) || u.target.isConnected !== !1 && (e.offsetWidth < 1 && e.offsetHeight < 1 || e._x_isShown !== !1 && s(u))
  })), n.includes("self") && (o = a(o, (s, u) => {
    u.target === e && s(u)
  })), (Vi(t) || Gn(t)) && (o = a(o, (s, u) => {
    $i(u, n) || s(u)
  })), c.addEventListener(t, o, r), () => {
    c.removeEventListener(t, o, r)
  }
}

function Fi(e) {
  return e.replace(/-/g, ".")
}

function Bi(e) {
  return e.toLowerCase()
    .replace(/-(\w)/g, (t, n) => n.toUpperCase())
}

function ge(e) {
  return !Array.isArray(e) && !isNaN(e)
}

function zi(e) {
  return [" ", "_"].includes(e) ? e : e.replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[_\s]/, "-")
    .toLowerCase()
}

function Vi(e) {
  return ["keydown", "keyup"].includes(e)
}

function Gn(e) {
  return ["contextmenu", "click", "mouse"].some(t => e.includes(t))
}

function $i(e, t) {
  let n = t.filter(o => !["window", "document", "prevent", "stop", "once", "capture", "self", "away", "outside", "passive", "preserve-scroll"].includes(o));
  if (n.includes("debounce")) {
    let o = n.indexOf("debounce");
    n.splice(o, ge((n[o + 1] || "invalid-wait")
      .split("ms")[0]) ? 2 : 1)
  }
  if (n.includes("throttle")) {
    let o = n.indexOf("throttle");
    n.splice(o, ge((n[o + 1] || "invalid-wait")
      .split("ms")[0]) ? 2 : 1)
  }
  if (n.length === 0 || n.length === 1 && Et(e.key)
    .includes(n[0])) return !1;
  const c = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter(o => n.includes(o));
  return n = n.filter(o => !c.includes(o)), !(c.length > 0 && c.filter(r => ((r === "cmd" || r === "super") && (r = "meta"), e[`${r}Key`]))
    .length === c.length && (Gn(e.type) || Et(e.key)
      .includes(n[0])))
}

function Et(e) {
  if (!e) return [];
  e = zi(e);
  let t = {
    ctrl: "control",
    slash: "/",
    space: " ",
    spacebar: " ",
    cmd: "meta",
    esc: "escape",
    up: "arrow-up",
    down: "arrow-down",
    left: "arrow-left",
    right: "arrow-right",
    period: ".",
    comma: ",",
    equal: "=",
    minus: "-",
    underscore: "_"
  };
  return t[e] = e, Object.keys(t)
    .map(n => {
      if (t[n] === e) return n
    })
    .filter(n => n)
}
y("model", (e, {
  modifiers: t,
  expression: n
}, {
  effect: i,
  cleanup: c
}) => {
  let o = e;
  t.includes("parent") && (o = e.parentNode);
  let r = O(o, n),
    a;
  typeof n == "string" ? a = O(o, `${n} = __placeholder`) : typeof n == "function" && typeof n() == "string" ? a = O(o, `${n()} = __placeholder`) : a = () => {};
  let s = () => {
      let h;
      return r(_ => h = _), Pt(h) ? h.get() : h
    },
    u = h => {
      let _;
      r(f => _ = f), Pt(_) ? _.set(h) : a(() => {}, {
        scope: {
          __placeholder: h
        }
      })
    };
  typeof n == "string" && e.type === "radio" && S(() => {
    e.hasAttribute("name") || e.setAttribute("name", n)
  });
  let d = e.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(e.type) || t.includes("lazy") ? "change" : "input",
    p = q ? () => {} : $e(e, d, t, h => {
      u(Ae(e, t, h, s()))
    });
  if (t.includes("fill") && ([void 0, null, ""].includes(s()) || ut(e) && Array.isArray(s()) || e.tagName.toLowerCase() === "select" && e.multiple) && u(Ae(e, t, {
      target: e
    }, s())), e._x_removeModelListeners || (e._x_removeModelListeners = {}), e._x_removeModelListeners.default = p, c(() => e._x_removeModelListeners.default()), e.form) {
    let h = $e(e.form, "reset", [], _ => {
      at(() => e._x_model && e._x_model.set(Ae(e, t, {
        target: e
      }, s())))
    });
    c(() => h())
  }
  e._x_model = {
    get() {
      return s()
    },
    set(h) {
      u(h)
    }
  }, e._x_forceModelUpdate = h => {
    h === void 0 && typeof n == "string" && n.match(/\./) && (h = ""), window.fromModel = !0, S(() => Wn(e, "value", h)), delete window.fromModel
  }, i(() => {
    let h = s();
    t.includes("unintrusive") && document.activeElement.isSameNode(e) || e._x_forceModelUpdate(h)
  })
});

function Ae(e, t, n, i) {
  return S(() => {
    if (n instanceof CustomEvent && n.detail !== void 0) return n.detail !== null && n.detail !== void 0 ? n.detail : n.target.value;
    if (ut(e))
      if (Array.isArray(i)) {
        let c = null;
        return t.includes("number") ? c = Le(n.target.value) : t.includes("boolean") ? c = pe(n.target.value) : c = n.target.value, n.target.checked ? i.includes(c) ? i : i.concat([c]) : i.filter(o => !Ui(o, c))
      } else return n.target.checked;
    else {
      if (e.tagName.toLowerCase() === "select" && e.multiple) return t.includes("number") ? Array.from(n.target.selectedOptions)
        .map(c => {
          let o = c.value || c.text;
          return Le(o)
        }) : t.includes("boolean") ? Array.from(n.target.selectedOptions)
        .map(c => {
          let o = c.value || c.text;
          return pe(o)
        }) : Array.from(n.target.selectedOptions)
        .map(c => c.value || c.text);
      {
        let c;
        return mn(e) ? n.target.checked ? c = n.target.value : c = i : c = n.target.value, t.includes("number") ? Le(c) : t.includes("boolean") ? pe(c) : t.includes("trim") ? c.trim() : c
      }
    }
  })
}

function Le(e) {
  let t = e ? parseFloat(e) : null;
  return Xi(t) ? t : e
}

function Ui(e, t) {
  return e == t
}

function Xi(e) {
  return !Array.isArray(e) && !isNaN(e)
}

function Pt(e) {
  return e !== null && typeof e == "object" && typeof e.get == "function" && typeof e.set == "function"
}
y("cloak", e => queueMicrotask(() => S(() => e.removeAttribute(U("cloak")))));
sn(() => `[${U("init")}]`);
y("init", J((e, {
  expression: t
}, {
  evaluate: n
}) => typeof t == "string" ? !!t.trim() && n(t, {}, !1) : n(t, {}, !1)));
y("text", (e, {
  expression: t
}, {
  effect: n,
  evaluateLater: i
}) => {
  let c = i(t);
  n(() => {
    c(o => {
      S(() => {
        e.textContent = o
      })
    })
  })
});
y("html", (e, {
  expression: t
}, {
  effect: n,
  evaluateLater: i
}) => {
  let c = i(t);
  n(() => {
    c(o => {
      S(() => {
        e.innerHTML = o, e._x_ignoreSelf = !0, L(e), delete e._x_ignoreSelf
      })
    })
  })
});
it(Xt(":", Zt(U("bind:"))));
var Hn = (e, {
  value: t,
  modifiers: n,
  expression: i,
  original: c
}, {
  effect: o,
  cleanup: r
}) => {
  if (!t) {
    let s = {};
    ni(s), O(e, i)(d => {
      yn(e, d, c)
    }, {
      scope: s
    });
    return
  }
  if (t === "key") return Zi(e, i);
  if (e._x_inlineBindings && e._x_inlineBindings[t] && e._x_inlineBindings[t].extract) return;
  let a = O(e, i);
  o(() => a(s => {
    s === void 0 && typeof i == "string" && i.match(/\./) && (s = ""), S(() => Wn(e, t, s, n))
  })), r(() => {
    e._x_undoAddedClasses && e._x_undoAddedClasses(), e._x_undoAddedStyles && e._x_undoAddedStyles()
  })
};
Hn.inline = (e, {
  value: t,
  modifiers: n,
  expression: i
}) => {
  t && (e._x_inlineBindings || (e._x_inlineBindings = {}), e._x_inlineBindings[t] = {
    expression: i,
    extract: !1
  })
};
y("bind", Hn);

function Zi(e, t) {
  e._x_keyExpression = t
}
an(() => `[${U("data")}]`);
y("data", (e, {
  expression: t
}, {
  cleanup: n
}) => {
  if (Yi(e)) return;
  t = t === "" ? "{}" : t;
  let i = {};
  Ke(i, e);
  let c = {};
  ii(c, i);
  let o = G(e, t, {
    scope: c
  });
  (o === void 0 || o === !0) && (o = {}), Ke(o, e);
  let r = V(o);
  Ht(r);
  let a = ce(e, r);
  r.init && G(e, r.init), n(() => {
    r.destroy && G(e, r.destroy), a()
  })
});
ye((e, t) => {
  e._x_dataStack && (t._x_dataStack = e._x_dataStack, t.setAttribute("data-has-alpine-state", !0))
});

function Yi(e) {
  return q ? Fe ? !0 : e.hasAttribute("data-has-alpine-state") : !1
}
y("show", (e, {
  modifiers: t,
  expression: n
}, {
  effect: i
}) => {
  let c = O(e, n);
  e._x_doHide || (e._x_doHide = () => {
    S(() => {
      e.style.setProperty("display", "none", t.includes("important") ? "important" : void 0)
    })
  }), e._x_doShow || (e._x_doShow = () => {
    S(() => {
      e.style.length === 1 && e.style.display === "none" ? e.removeAttribute("style") : e.style.removeProperty("display")
    })
  });
  let o = () => {
      e._x_doHide(), e._x_isShown = !1
    },
    r = () => {
      e._x_doShow(), e._x_isShown = !0
    },
    a = () => setTimeout(r),
    s = Qe(p => p ? r() : o(), p => {
      typeof e._x_toggleAndCascadeWithTransitions == "function" ? e._x_toggleAndCascadeWithTransitions(e, p, r, o) : p ? a() : o()
    }),
    u, d = !0;
  i(() => c(p => {
    !d && p === u || (t.includes("immediate") && (p ? a() : o()), s(p), u = p, d = !1)
  }))
});
y("for", (e, {
  expression: t
}, {
  effect: n,
  cleanup: i
}) => {
  let c = to(t),
    o = O(e, c.items),
    r = O(e, e._x_keyExpression || "index");
  e._x_prevKeys = [], e._x_lookup = {}, n(() => eo(e, c, o, r)), i(() => {
    Object.values(e._x_lookup)
      .forEach(a => S(() => {
        Z(a), a.remove()
      })), delete e._x_prevKeys, delete e._x_lookup
  })
});

function eo(e, t, n, i) {
  let c = r => typeof r == "object" && !Array.isArray(r),
    o = e;
  n(r => {
    no(r) && r >= 0 && (r = Array.from(Array(r)
      .keys(), x => x + 1)), r === void 0 && (r = []);
    let a = e._x_lookup,
      s = e._x_prevKeys,
      u = [],
      d = [];
    if (c(r)) r = Object.entries(r)
      .map(([x, W]) => {
        let m = At(t, W, x, r);
        i(g => {
          d.includes(g) && v("Duplicate key on x-for", e), d.push(g)
        }, {
          scope: {
            index: x,
            ...m
          }
        }), u.push(m)
      });
    else
      for (let x = 0; x < r.length; x++) {
        let W = At(t, r[x], x, r);
        i(m => {
          d.includes(m) && v("Duplicate key on x-for", e), d.push(m)
        }, {
          scope: {
            index: x,
            ...W
          }
        }), u.push(W)
      }
    let p = [],
      h = [],
      _ = [],
      f = [];
    for (let x = 0; x < s.length; x++) {
      let W = s[x];
      d.indexOf(W) === -1 && _.push(W)
    }
    s = s.filter(x => !_.includes(x));
    let l = "template";
    for (let x = 0; x < d.length; x++) {
      let W = d[x],
        m = s.indexOf(W);
      if (m === -1) s.splice(x, 0, W), p.push([l, x]);
      else if (m !== x) {
        let g = s.splice(x, 1)[0],
          b = s.splice(m - 1, 1)[0];
        s.splice(x, 0, b), s.splice(m, 0, g), h.push([g, b])
      } else f.push(W);
      l = W
    }
    for (let x = 0; x < _.length; x++) {
      let W = _[x];
      W in a && (S(() => {
        Z(a[W]), a[W].remove()
      }), delete a[W])
    }
    for (let x = 0; x < h.length; x++) {
      let [W, m] = h[x], g = a[W], b = a[m], P = document.createElement("div");
      S(() => {
        b || v('x-for ":key" is undefined or invalid', o, m, a), b.after(P), g.after(b), b._x_currentIfEl && b.after(b._x_currentIfEl), P.before(g), g._x_currentIfEl && g.after(g._x_currentIfEl), P.remove()
      }), b._x_refreshXForScope(u[d.indexOf(m)])
    }
    for (let x = 0; x < p.length; x++) {
      let [W, m] = p[x], g = W === "template" ? o : a[W];
      g._x_currentIfEl && (g = g._x_currentIfEl);
      let b = u[m],
        P = d[m],
        T = document.importNode(o.content, !0)
        .firstElementChild,
        ht = V(b);
      ce(T, ht, o), T._x_refreshXForScope = Fn => {
        Object.entries(Fn)
          .forEach(([Bn, zn]) => {
            ht[Bn] = zn
          })
      }, S(() => {
        g.after(T), J(() => L(T))()
      }), typeof P == "object" && v("x-for key cannot be an object, it must be a string or an integer", o), a[P] = T
    }
    for (let x = 0; x < f.length; x++) a[f[x]]._x_refreshXForScope(u[d.indexOf(f[x])]);
    o._x_prevKeys = d
  })
}

function to(e) {
  let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
    n = /^\s*\(|\)\s*$/g,
    i = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
    c = e.match(i);
  if (!c) return;
  let o = {};
  o.items = c[2].trim();
  let r = c[1].replace(n, "")
    .trim(),
    a = r.match(t);
  return a ? (o.item = r.replace(t, "")
    .trim(), o.index = a[1].trim(), a[2] && (o.collection = a[2].trim())) : o.item = r, o
}

function At(e, t, n, i) {
  let c = {};
  return /^\[.*\]$/.test(e.item) && Array.isArray(t) ? e.item.replace("[", "")
    .replace("]", "")
    .split(",")
    .map(r => r.trim())
    .forEach((r, a) => {
      c[r] = t[a]
    }) : /^\{.*\}$/.test(e.item) && !Array.isArray(t) && typeof t == "object" ? e.item.replace("{", "")
    .replace("}", "")
    .split(",")
    .map(r => r.trim())
    .forEach(r => {
      c[r] = t[r]
    }) : c[e.item] = t, e.index && (c[e.index] = n), e.collection && (c[e.collection] = i), c
}

function no(e) {
  return !Array.isArray(e) && !isNaN(e)
}

function Qn() {}
Qn.inline = (e, {
  expression: t
}, {
  cleanup: n
}) => {
  let i = Se(e);
  i._x_refs || (i._x_refs = {}), i._x_refs[t] = e, n(() => delete i._x_refs[t])
};
y("ref", Qn);
y("if", (e, {
  expression: t
}, {
  effect: n,
  cleanup: i
}) => {
  e.tagName.toLowerCase() !== "template" && v("x-if can only be used on a <template> tag", e);
  let c = O(e, t),
    o = () => {
      if (e._x_currentIfEl) return e._x_currentIfEl;
      let a = e.content.cloneNode(!0)
        .firstElementChild;
      return ce(a, {}, e), S(() => {
        e.after(a), J(() => L(a))()
      }), e._x_currentIfEl = a, e._x_undoIf = () => {
        S(() => {
          Z(a), a.remove()
        }), delete e._x_currentIfEl
      }, a
    },
    r = () => {
      e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf)
    };
  n(() => c(a => {
    a ? o() : r()
  })), i(() => e._x_undoIf && e._x_undoIf())
});
y("id", (e, {
  expression: t
}, {
  evaluate: n
}) => {
  n(t)
    .forEach(c => Hi(e, c))
});
ye((e, t) => {
  e._x_ids && (t._x_ids = e._x_ids)
});
it(Xt("@", Zt(U("on:"))));
y("on", J((e, {
  value: t,
  modifiers: n,
  expression: i
}, {
  cleanup: c
}) => {
  let o = i ? O(e, i) : () => {};
  e.tagName.toLowerCase() === "template" && (e._x_forwardEvents || (e._x_forwardEvents = []), e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
  let r = $e(e, t, n, a => {
    o(() => {}, {
      scope: {
        $event: a
      },
      params: [a]
    })
  });
  c(() => r())
}));
we("Collapse", "collapse", "collapse");
we("Intersect", "intersect", "intersect");
we("Focus", "trap", "focus");
we("Mask", "mask", "mask");

function we(e, t, n) {
  y(t, i => v(`You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`, i))
}
se.setEvaluator(zt);
se.setReactivityEngine({
  reactive: _t,
  effect: Wi,
  release: pi,
  raw: k
});
var ro = se,
  Dn = ro;
window.Alpine = Dn;
const io = {
  FREE_GIFT_STORE: "freeGiftStore"
};
window.AlpineStoreKeys = io;
Dn.start();

